import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import SocialIcon from '~/components/Shared/Social/SocialIcon';
import type { COLOR } from '~/types/AppData/Theme/ColorInterface';
import type { SocialLinkInterface } from '~/types/AppData/Layout/SocialLinkInterface';

type SocialIconsType = {
  title?: string;
  color: COLOR;
  hoverColor: COLOR;
  icons: SocialLinkInterface[];
  titleClasses?: string;
};

export default component$<SocialIconsType>(
  ({ title, titleClasses, color, hoverColor, icons }): JSX.Element => {
    return (
      <nav>
        {title && <h4 class={titleClasses ?? ''}>{title}</h4>}
        <ul class='inline-grid gap-5 grid-flow-col list-none'>
          {icons.map((each, index) => {
            return (
              <li class='flex w-5 justify-center' key={index}>
                <SocialIcon icon={each} color={color} hoverColor={hoverColor} />
              </li>
            );
          })}
        </ul>
      </nav>
    );
  }
);
